import { render, staticRenderFns } from "./ExtraServiceParsec.vue?vue&type=template&id=1c0befd6"
import script from "@/scripts/modal/extraService/extraServiceParsec.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/extraService/extraServiceParsec.js?vue&type=script&lang=js&external"
import style0 from "./ExtraServiceParsec.vue?vue&type=style&index=0&id=1c0befd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports